// Driver verification documents — mirrors iOS DriverDocumentType.
// Each doc writes `{prefix}URL` / `{prefix}Status` / `{prefix}SubmittedAt`
// on drivers/{id} and stores the image at
// permits/drivers/{id}/{file}.jpg for admin review.
export const DRIVER_DOC_TYPES = {
  selfie: {
    key: 'selfie',
    fieldPrefix: 'selfie',
    file: 'selfie',
    title: 'Selfie',
    frontCamera: true,
    instructions:
      'Take a clear selfie of your face — no sunglasses or hat. We use this to verify it is really you making deliveries.',
  },
  driversLicense: {
    key: 'driversLicense',
    fieldPrefix: 'driversLicense',
    file: 'drivers-license',
    title: "Driver's License",
    frontCamera: false,
    instructions:
      'Take a clear photo of your valid driver\'s license. All text must be readable.',
  },
  vehiclePhoto: {
    key: 'vehiclePhoto',
    fieldPrefix: 'vehiclePhoto',
    file: 'vehicle',
    title: 'Vehicle / E-Bike Photo',
    frontCamera: false,
    instructions:
      'Take a photo of the vehicle or e-bike you deliver with, so we can verify it can handle deliveries.',
  },
  deliveryBag: {
    key: 'deliveryBag',
    fieldPrefix: 'deliveryBag',
    file: 'delivery-bag',
    title: 'Delivery Bag',
    frontCamera: false,
    instructions:
      'Take a photo of the insulated delivery bag you carry orders in. Every driver needs one.',
  },
};

// Everyone: selfie + delivery bag (+ food handler's permit, handled by
// PermitSheet). Car / Scooter / Bicycle: also a vehicle photo.
// Car / Scooter: also a driver's license. Walking: no vehicle docs.
export function requiredDriverDocs(vehicleType) {
  const v = (vehicleType || '').toLowerCase();
  const docs = [DRIVER_DOC_TYPES.selfie, DRIVER_DOC_TYPES.deliveryBag];
  if (v === 'car' || v === 'scooter') {
    docs.splice(1, 0, DRIVER_DOC_TYPES.driversLicense, DRIVER_DOC_TYPES.vehiclePhoto);
  } else if (v === 'bicycle') {
    docs.splice(1, 0, DRIVER_DOC_TYPES.vehiclePhoto);
  }
  return docs;
}

export function docStatusLabel(driver, docType) {
  const prefix = docType.fieldPrefix;
  const status = driver?.[`${prefix}Status`] || driver?.raw?.[`${prefix}Status`];
  const url = driver?.[`${prefix}URL`] || driver?.raw?.[`${prefix}URL`];
  if (status === 'approved') return 'Approved';
  if (status === 'rejected') return 'Rejected';
  if (status === 'pending' || url) return 'Pending Review';
  return 'Required';
}
